import useFetch from '../http/api'

export default function Taxonomies() {
	const { data, loading } = useFetch(`${process.env.API_URL}/taxonomias`)

	if (loading) return <p>Carregando produtos...</p>
	if (!data) return <p>Não há Filtros</p>

	const handleTermClick = (taxonomyName, termSlug) => {
		const params = new URLSearchParams(window.location.search) // Obtém os parâmetros atuais
		params.set(taxonomyName, termSlug) // Adiciona ou atualiza o parâmetro
		const newUrl = `${window.location.pathname}?${params.toString()}` // Cria a nova URL
		window.history.pushState({}, '', newUrl) // Atualiza a URL sem recarregar
	}

	return (
		<div>
			{data.map((tax) => (
				<div key={tax.name} className="w-full">
					<h3>{tax.label}</h3>
					<p>{tax.description}</p>

					<div>
						<ul>
							{tax.terms.map((term) => (
								<li
									key={term.id}
									className="cursor-pointer text-blue-500 underline"
									onClick={() => handleTermClick(tax.name, term.slug)}
								>
									{term.name} ({term.count})
								</li>
							))}
						</ul>
					</div>
				</div>
			))}
		</div>
	)
}
